export const products = [
  {
    id: '324254',
    name: 'HOODIE SWEATSHIRT',
    description: 'Relaxed fit hoodie sweatshirt made of dense cotton with brushed interior. Hooded collar and long sleeves. Front pouch pocket. Rib trim.',
    price: 90.30,
    originalPrice: 120.00,
    color: 'Ecru',
    colors: [
      { name: 'Ecru', hex: '#E8E4D9', available: true },
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'Sage', hex: '#8B9A8E', available: true },
      { name: 'Navy', hex: '#1A2E4C', available: false }
    ],
    material: '100% cotton',
    category: 'Outerwear',
    image: '/images/products/photo-1576188973526-0e5d7047b0cf.jpg',
    images: [
      '/images/products/photo-1576188973526-0e5d7047b0cf.jpg',
      '/images/products/photo-1618677603544-51162346e165.jpg',
      '/images/products/photo-1643387848945-da63360662f4.jpg',
      '/images/products/photo-1565437785801-27a6c88db1f0.jpg'
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Machine wash cold with like colors',
      'Tumble dry low',
      'Do not bleach',
      'Iron on low heat if needed'
    ],
    breadcrumb: ['Home', 'Outerwear', 'Hoodies']
  },
  {
    id: '324255',
    name: 'BASIC T-SHIRT',
    description: 'Classic fit t-shirt in premium cotton. Crew neck with short sleeves. Regular fit. Crafted from the finest premium cotton, offering a soft, breathable feel for all-day comfort.',
    price: 27.54,
    originalPrice: 35.00,
    color: 'White',
    colors: [
      { name: 'White', hex: '#ffffff', available: true },
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'Grey', hex: '#9ca3af', available: true }
    ],
    material: '100% organic cotton',
  category: 'Tops',
    image: '/images/products/photo-1618677603544-51162346e165.jpg',
    images: [
      '/images/products/photo-1618677603544-51162346e165.jpg',
      '/images/products/photo-1657364890927-5dd04b231a6d.jpg',
      '/images/products/photo-1657364890995-1ec4bb3aefcf.jpg'
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      '100% Pima Cotton',
      'Machine wash cold with like colors',
      'Tumble dry low',
      'Do not bleach'
    ],
  breadcrumb: ['Home', 'Tops', 'T-Shirts']
  },
  {
    id: '324256',
    name: 'BASEBALL CAP',
    description: 'Classic baseball cap with adjustable strap. Cotton twill construction with embroidered details. Perfect for casual everyday wear.',
    price: 19.20,
    originalPrice: 25.00,
    color: 'Black',
    colors: [
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'Sage', hex: '#8B9A8E', available: true },
      { name: 'Beige', hex: '#E8E4D9', available: true }
    ],
    material: 'Cotton twill',
    category: 'Caps',
    image: '/images/products/photo-1627733041826-77dd65dc5a19.jpg',
    images: [
      '/images/products/photo-1627733041826-77dd65dc5a19.jpg',
      '/images/products/photo-1737438696465-516c17c5e0f8.jpg',
      '/images/products/photo-1733127547242-42a2e7ac12bb.jpg'
    ],
    sizes: ['One Size'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Spot clean only',
      'Do not machine wash',
      'Air dry'
    ],
    breadcrumb: ['Home', 'Accessories', 'Caps']
  },
  {
    id: '324257',
    name: 'PHONE CASE',
    description: 'Minimalist phone case with premium matte finish. Slim profile with precise cutouts. Provides excellent protection without bulk.',
    price: 6.20,
    originalPrice: 10.00,
    color: 'White',
    colors: [
      { name: 'White', hex: '#ffffff', available: true },
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'Sage', hex: '#8B9A8E', available: true }
    ],
    material: 'Polycarbonate',
    category: 'Accessories',
    image: '/images/products/photo-1672883589583-c82951069154.jpg',
    images: [
      '/images/products/photo-1672883589583-c82951069154.jpg'
    ],
    sizes: ['iPhone 14', 'iPhone 15'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Wipe clean with damp cloth',
      'Do not use harsh chemicals'
    ],
    breadcrumb: ['Home', 'Accessories', 'Phone Cases']
  },
  {
    id: '324258',
    name: 'OVERSIZED HOODIE',
    description: 'Oversized fit hoodie in premium heavyweight cotton. Drop shoulder design with kangaroo pocket. Ultimate comfort meets contemporary style.',
    price: 95.00,
    originalPrice: 125.00,
    color: 'Sand',
    colors: [
      { name: 'Sand', hex: '#D5D0C1', available: true },
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'Olive', hex: '#6B7259', available: true }
    ],
    material: '100% cotton',
    category: 'Outerwear',
    image: '/images/products/photo-1576188973526-0e5d7047b0cf.jpg',
    images: [
      '/images/products/photo-1576188973526-0e5d7047b0cf.jpg'
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Machine wash cold',
      'Tumble dry low',
      'Do not bleach',
      'Iron inside out on low heat'
    ],
    breadcrumb: ['Home', 'Outerwear', 'Hoodies']
  },
  {
    id: '324259',
    name: 'BLACK ESSENTIAL TEE',
    description: 'Essential black t-shirt with modern fit. Soft cotton jersey with reinforced seams. A wardrobe staple that never goes out of style.',
    price: 29.90,
    originalPrice: 40.00,
    color: 'Black',
    colors: [
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'White', hex: '#ffffff', available: true },
      { name: 'Charcoal', hex: '#4B5563', available: true }
    ],
    material: '100% cotton',
  category: 'Tops',
    image: '/images/products/photo-1657364890927-5dd04b231a6d.jpg',
    images: [
      '/images/products/photo-1657364890927-5dd04b231a6d.jpg',
      '/images/products/photo-1657364890995-1ec4bb3aefcf.jpg'
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Machine wash cold',
      'Tumble dry low',
      'Do not bleach'
    ],
  breadcrumb: ['Home', 'Tops', 'T-Shirts']
  },
  {
    id: '324260',
    name: 'STRUCTURED CAP',
    description: 'Premium structured cap with embroidered logo. Adjustable snapback closure. Perfect blend of style and functionality.',
    price: 24.50,
    originalPrice: 32.00,
    color: 'Grey',
    colors: [
      { name: 'Grey', hex: '#6B7280', available: true },
      { name: 'Black', hex: '#1a1a1a', available: true },
      { name: 'Navy', hex: '#1A2E4C', available: true }
    ],
    material: 'Cotton blend',
    category: 'Caps',
    image: '/images/products/photo-1737438696465-516c17c5e0f8.jpg',
    images: [
      '/images/products/photo-1737438696465-516c17c5e0f8.jpg'
    ],
    sizes: ['One Size'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Spot clean only',
      'Air dry',
      'Do not iron'
    ],
    breadcrumb: ['Home', 'Accessories', 'Caps']
  },
  {
    id: '324261',
    name: 'VINTAGE WASHED TEE',
    description: 'Vintage-washed t-shirt with relaxed fit. Soft, lived-in feel with distressed details. Effortlessly cool and comfortable.',
    price: 32.00,
    originalPrice: 45.00,
    color: 'Sage',
    colors: [
      { name: 'Sage', hex: '#8B9A8E', available: true },
      { name: 'Rust', hex: '#B7472A', available: true },
      { name: 'Washed Blue', hex: '#6B8E9F', available: true }
    ],
    material: '100% cotton',
  category: 'Tops',
    image: '/images/products/photo-1618677603544-51162346e165.jpg',
    images: [
      '/images/products/photo-1618677603544-51162346e165.jpg'
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    inStock: true,
    delivery: '3-5 working days',
    care: [
      'Machine wash cold',
      'Tumble dry low',
      'Wash separately first time'
    ],
  breadcrumb: ['Home', 'Tops', 'T-Shirts']
  }
];

export const categories = [
  { name: 'Tops', slug: 'tops' },
  { name: 'Outerwear', slug: 'outerwear' },
  { name: 'Caps', slug: 'caps' },
  { name: 'Accessories', slug: 'accessories' }
];
